// @flow

import * as React from 'react';

import { Link } from 'react-router-dom';

import {
  selectCartIsActive,
  selectCartUUID,
  type ProductId,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Badge } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import LabelContent from './LabelContent';

export type Props = {
  productId: ProductId,
  hasValidSmdFile: boolean,
  productSmdData: string,
};

export default function SmdFileRow({
  hasValidSmdFile,
  productId,
  productSmdData,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartUUID);
  const active = useAppSelector(selectCartIsActive);
  const uploadButtonLabel = productSmdData !== '' ? __('Change') : __('Upload');

  return (
    <Base flex flexShrink0 gap="small" marginBottom="xsmall">
      <LabelContent label={__('Trademark claim')}>
        {!hasValidSmdFile && !productSmdData && (
          <Badge intent="warning">{__('SMD Mandatory')}</Badge>
        )}
        {productSmdData !== '' &&
          (hasValidSmdFile ? (
            <Badge intent="success">{__('SMD checked')}</Badge>
          ) : (
            <Badge intent="warning">{__('SMD Invalid')}</Badge>
          ))}
        <Link
          to={`/cart/${cartId}/configure/${productId}/smd`}
          disabled={!active}
        >
          {uploadButtonLabel}
        </Link>
      </LabelContent>
    </Base>
  );
}
